import { Button } from "@atoms"

import MenuItem from "@molecules/MenuItem/MenuItem"
import PopoverFooter from "@molecules/Popover/PopoverFooter/PopoverFooter"
import SelectListInput from "@molecules/Select/SelectListInput/SelectListInput"

import styles from "./SelectListFooter.module.scss"
import { SelectListFooterProps } from "./SelectListFooter.types"

export default function SelectListFooter(props: SelectListFooterProps) {
    const { variant } = props

    if (variant === "menu-item") {
        const { menuItem } = props
        return (
            <PopoverFooter.Root className={styles.menuItemBase}>
                <MenuItem {...menuItem} />
            </PopoverFooter.Root>
        )
    } else if (variant === "action-bar") {
        const { dismissButton, secondaryButton, confirmButton } = props
        return (
            <PopoverFooter.Root>
                <PopoverFooter.LeftSide>{dismissButton && <Button {...dismissButton} />}</PopoverFooter.LeftSide>
                <PopoverFooter.RightSide>
                    {secondaryButton && <Button {...secondaryButton} />}
                    {confirmButton && <Button {...confirmButton} />}
                </PopoverFooter.RightSide>
            </PopoverFooter.Root>
        )
    } else {
        const { selectInput } = props
        return (
            <PopoverFooter.Root className={styles.selectInputBase}>
                <SelectListInput {...selectInput} />
            </PopoverFooter.Root>
        )
    }
}
